import { z } from 'zod';

const NumberOrNullToUndefined = z
  .number()
  .optional()
  .nullable()
  .transform((nullableString) =>
    nullableString === null ? undefined : nullableString,
  );

export default NumberOrNullToUndefined;
